// @ts-nocheck
import Service from '@ember/service';
import { tracked } from '@glimmer/tracking';
import type {
  TaskInstanceForTaskFunction,
  TaskGenerator,
} from 'ember-concurrency';
import type Billing from 'billing-common/models/billing';
import type CurrentUserService from './current-user';
import type {
  HashicorpCloudResourcemanagerOrganization,
  HashicorpCloudResourcemanagerProject,
} from '@clients/cloud-resource-manager';
import type { Secrets20230613App } from '@clients/cloud-vault-secrets';
import type { HashicorpCloudBoundary20211221Cluster } from '@clients/cloud-boundary-service';
import type { HashicorpCloudVault20201125Cluster } from '@clients/cloud-vault-service';
import type { HashicorpCloudNetwork20200907Network } from '@clients/cloud-network';

export type Organization = HashicorpCloudResourcemanagerOrganization;
export type Project = HashicorpCloudResourcemanagerProject;

export interface OrganizationMeta {
  ssoEnabled: boolean;
  unifiedExperienceEnabled: boolean;
}

export interface User {
  key: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  custom?: Record<string, unknown>;
}

export type Resource =
  | HashicorpCloudBoundary20211221Cluster
  | HashicorpCloudVault20201125Cluster
  | HashicorpCloudNetwork20200907Network
  | Secrets20230613App;

// IMPORTANT: THIS IS NOT REAL SERVICE IMPLEMENTATION - JUST A STUB
// The real implementation is in 'hcp/services/user-context.js'
// this service is just to track the current org and project
// this is a simplified version of the user-context service that is in
// `cloud-ui` without the launch darkly configuration.
//
// its intended use is in test applications for engines
export default class UserContextService extends Service {
  @tracked project: Project | undefined;
  @tracked organization: Organization | undefined;
  @tracked organizationMeta: OrganizationMeta | undefined;
  @tracked resource: (Resource & { type: string }) | undefined;
  @tracked projects: Project[] | undefined = [];

  readonly currentUser: CurrentUserService;
  _projectsNextPageToken: string | null;
  billing: Billing | null;
  readonly identifyCall: TaskInstanceForTaskFunction;

  setOrganization(organization?: Organization): Promise<void> {
    this.organization = organization;
    this.updateOrganizationMeta();

    return Promise.resolve();
  }

  setProject(project?: Project): Promise<void> {
    this.project = project;
    return Promise.resolve();
  }

  setResource(resource: Resource | undefined, type?: string) {
    this.resource = {
      ...resource,
      type,
    };
  }

  identifyUser(user: User): TaskGenerator<void>;

  updateOrganizationMeta(diff = {}) {
    this.organizationMeta = { ...this.organizationMeta, ...diff };
  }

  setSsoEnabled(ssoEnabled) {
    this.updateOrganizationMeta({ ssoEnabled });
  }
}
